import 'bootstrap/js/src/dropdown'
import { CDN_PIVOT } from 'core/constants/endpoints'
import getPlans from 'core/controllerPlans/getPlans'
import updateStorages from 'core/controllerPlans/updateStorages'
import validateProfile from 'core/controllerPlans/validateProfile'
import forbidBTM from 'core/controllerPlansBTM/forbidBTM'
import initPage from 'core/initPage'
import parseResponseSTM from 'core/services/getPlansByProductId/parseResponseSTM'
import recommendTrackingEvents from 'core/services/recommendTrackingEvents'
import {
  registerCommands,
  runCommands
} from 'sites/pivothealth.com/scripts/commands/register'
import fetchJSONHandleError from 'utils/NET/fetchJSONHandleError'
import config from './config'
import handleResponseFromEndpoints from './controller/handleResponseFromEndpoints'
import finish from './finish'
import './styles.scss'
import updateMultiCarrierEligibility from 'core/controllerPlans/update-multi-carrier-eligibility'
import createAndSaveQuoteMetadata from 'core/controllerPlans/create-and-save-quote-metadata'
import handleException from 'core/controllers/handleException'
import { QUOTES } from 'sites/routes'

registerCommands()

initPage({
  placement: config.placement,
  chatInteractionId: config.chatInteractionId,
  tags: ['Quotes']
})
  .then(forbidBTM)
  .then(updateStorages)
  .then(updateMultiCarrierEligibility)
  .then(validateProfile)
  .then(getPlans)
  .then(getPlansResponse =>
    Promise.all([
      ...getPlansResponse,
      fetchJSONHandleError({
        url: `${CDN_PIVOT}/resources/default-plans/defaultPlans.json`
      })
    ])
  )
  .then(parseResponseSTM)
  .then(handleResponseFromEndpoints)
  .then(createAndSaveQuoteMetadata(QUOTES))
  .then(recommendTrackingEvents)
  .then(finish)
  .then(runCommands)
  .catch(handleException())
